import { demoMessages } from "./demo-messages";

export const messagesQuery = {
  read(_: any) {
    return demoMessages;
  },
};
